import { Avatar } from "@common-ui/ui";
import { getAvatarInitials } from "../../../utils";

export const ClientPlaceProfileImage = (props) => {
  const initials = props?.data?.name || props?.data?.screen_name;
  const image_url = props?.data?.logo;
  if (image_url) {
    return (
      <img
        src={image_url}
        srcSet={image_url}
        alt={initials}
        loading="lazy"
        style={{ height: 70, width: 70, objectFit: "contain" }}
      />
    );
  }
  return (
    <Avatar
      variant="round"
      alt={initials}
      src={getAvatarInitials(initials)}
      sx={{ height: 70, width: 70 }}
    />
  );
};
